import { jsx, jsxs } from "react/jsx-runtime";
import { Suspense, useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Flex } from "antd";
import PlayerApi from "./../../api/PlayerApi.js";
import { withScrollToTop } from "./../../hoc";
import Loader from "./../../components/loader/Loader.js";
import HeaderTabs from "./../../components/tabComponents/HeaderTabs.js";
import TabsTabItems from "./../../components/tabComponents/TabsTabItems.js";
import useTabItems from "./../../hook/useTabItems.js";
import { Components } from "./playerContent/playerContentService";
import PlayerHeader from "./playerHeader/PlayerHeader";
const PlayerDetails = () => {
  const { id } = useParams();
  const getPlayerDetailsApi = PlayerApi.getPlayerDetails();
  const [playerDetails, setPlayerDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const tabItems = useMemo(
    () => {
      var _a;
      return (_a = playerDetails == null ? void 0 : playerDetails.tabItems) != null ? _a : [];
    },
    [playerDetails]
  );
  const {
    items,
    activeTabKey,
    activeTabData,
    tabsActiveTabId,
    setActiveTabKey,
    setTabsActiveTabId
  } = useTabItems({ tabItems });
  const Component = useMemo(
    () => {
      var _a;
      return (_a = Components[activeTabKey]) != null ? _a : Loader;
    },
    [activeTabKey]
  );
  useEffect(() => {
    setLoading(true);
    getPlayerDetails(id);
    return () => {
      getPlayerDetailsApi.cancel();
    };
  }, [id]);
  const getPlayerDetails = useCallback(async (id2) => {
    try {
      const response = await getPlayerDetailsApi.call(id2);
      setPlayerDetails(response.data);
    } catch (error) {
      console.error("Error fetching player details:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  return loading && !playerDetails ? /* @__PURE__ */ jsx(Loader, {}) : /* @__PURE__ */ jsxs(
    Flex,
    {
      vertical: true,
      gap: 24,
      className: "player-details",
      style: {
        position: "relative"
      },
      children: [
        loading && /* @__PURE__ */ jsx(Loader, { overlay: true }),
        /* @__PURE__ */ jsx(
          PlayerHeader,
          {
            photoUrl: playerDetails == null ? void 0 : playerDetails.photoUrl,
            name: playerDetails == null ? void 0 : playerDetails.displayName,
            currentTeam: playerDetails == null ? void 0 : playerDetails.currentTeam,
            isFavorite: playerDetails == null ? void 0 : playerDetails.isFavorite,
            itemId: playerDetails == null ? void 0 : playerDetails.id,
            children: /* @__PURE__ */ jsx(
              HeaderTabs,
              {
                items,
                activeTabKey,
                setActiveTabKey
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(Flex, { vertical: true, gap: 16, children: [
          /* @__PURE__ */ jsx(
            TabsTabItems,
            {
              activeTabData,
              tabItemId: tabsActiveTabId,
              setTabsActiveTabId,
              radioStyleType: "secondary"
            }
          ),
          /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Loader, {}), children: /* @__PURE__ */ jsx(
            Component,
            {
              data: activeTabData,
              tabItemId: tabsActiveTabId
            }
          ) })
        ] })
      ]
    }
  );
};
var stdin_default = withScrollToTop(PlayerDetails);
export {
  stdin_default as default
};
